import React from "react";
import { Grid } from "@mui/material";
import FormDatePicker from "components/FormFields/FormDatePicker";
import dayjs from "dayjs";
import { REPORT_MIN_DATE } from "static/constants";
import { dateStyle } from "./daterangeFilterStyle";

const DateRangeFilter = ({
  startDate,
  endDate,
  handleStartDate,
  handleEndDate,
  style,
  startGridProps = {},
  endGridProps = {},
}) => {
  return (
    <>
      <Grid item {...startGridProps}>
        <FormDatePicker
          name="start_date"
          required
          label="Start Date"
          minDate={dayjs(REPORT_MIN_DATE)}
          maxDate={dayjs(new Date())}
          variant="standard"
          value={dayjs(startDate)}
          onChange={handleStartDate}
          sx={style || dateStyle}
          manuallyEditable={false}
        />
      </Grid>

      <Grid item {...endGridProps}>
        <FormDatePicker
          name="end_date"
          required
          label="End Date"
          minDate={dayjs(REPORT_MIN_DATE)}
          maxDate={dayjs(new Date())}
          value={dayjs(endDate)}
          onChange={handleEndDate}
          variant="standard"
          sx={style || dateStyle}
          manuallyEditable={false}
        />
      </Grid>
    </>
  );
};

export default DateRangeFilter;
